import React, {useEffect,useContext} from 'react';
import useForm from 'react-hook-form';
import { useTranslation, Trans } from 'react-i18next';
import moment from "moment";
import Datetime from "react-datetime";

//components 
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardFooter from "beaktShared/components/Card/CardFooter.js";
import Badge from "beaktShared/components/Badge/Badge.js";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Button from "beaktShared/components/CustomButtons/Button.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import CircularProgress from '@material-ui/core/CircularProgress';

//graph
import PieGraph from './Graficos/PieGraph';
import Pie2Graph from './Graficos/Pie2Graph';
import LineGraph from './Graficos/LineGraph';
import BarGraph from './Graficos/BarGraph';
import Bar2Graph from './Graficos/Bar2Graph';

//icons
import Equalizer from "@material-ui/icons/Equalizer";
import Timeline from "@material-ui/icons/Timeline";
import TimerOff from "@material-ui/icons/TimerOff";
import BarChart from "@material-ui/icons/BarChart";
import PieChart from "@material-ui/icons/PieChart";

//services
import { MaskDate, validateDate, convertDate, formateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import { FormControl } from '@material-ui/core';
const useStyles = makeStyles(styles);

export default function Dashboard() {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);
  const { register,  errors, clearError,setError,getValues } = useForm({mode: "onBlur"});
  const [notification, setNotification] = React.useState({
    show:false,
    color:'info',
    message:''
  });
  const showNotification = (message,color) => { 
      setNotification({
      show:true,
      color:color,
      message:message      
      });
      setTimeout(function() {
      setNotification({show:false});
      }, 6000);       
  };

  const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-7, 'days')));
  const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));
  
  useEffect(() => {                
    handleClickPesquisa();
  }, []);

  const monthDiff = (dateFrom, dateTo) => {
      return dateTo.getMonth() - dateFrom.getMonth() + 
      (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
  }
  
  const handleClickPesquisa = () =>{
      
    let data = getValues();      
    if(data.dtini === "")
    {
        setError("dtini","required", t('label.required'))
        return false;
    }
    else
        clearError("dtini")
    
    if(data.dtfim === "")
    {
        setError("dtfim","required", "Campo Obrigatório")
        return false;
    }
    else
        clearError("dtfim")
    
    if (!validateDate(data.dtini)) {
        setError("dtini", "invaliddate", t('error_message.invalid_date'))
        return false;
    }
    else
        clearError("dtini")
    
    if (!validateDate(data.dtfim)) {
        setError("dtfim", "invaliddate", t('error_message.invalid_date'))
        return false;
    }
    else
        clearError("dtfim")
    
    var dataIniConvertida = convertDate(data.dtini);
    var dataFimConvertida = convertDate(data.dtfim);
    
    if(monthDiff(dataIniConvertida,dataFimConvertida) > 1){            
        showNotification(t('error_message.select_1month'), 'danger')
        return false; 
    }       

    let obj = {
        dataIni:dataIniConvertida,
        dataFim:dataFimConvertida
    }  
    loadDados(obj);
  };
  
  const loadDados = (obj) =>{ 
    loadTotalizadoresVendas(obj);
    loadQtdContratoxCanalMidia(obj);
    loadTIcketsMedios(obj);
    loadVendasxPagamentos(obj);
    loadAvaliacaoXVendas(obj);
    loadTop5Produtos(obj);
    loadTop5Servicos(obj);
    loadTop5Pacotes(obj);
    loadTop10Vendedores(obj);
    loadTop10Clientes(obj);
  }

  const [loadingT, setloadingT] = React.useState(false);
  const [totalizadores, settotalizadores] = React.useState([]);
  const loadTotalizadoresVendas=(obj)=>{  
    setloadingT(true);       
    const endPoint = "dashboard/totalizadortipovenda/"+session.estabelecimentoId;
    UsePostApi(endPoint,obj).then(result=>{    
        if(result.status !== 200)
        {   
            showNotification(result.message, 'danger')
            setloadingT(false);
            return false; 
        }   
        settotalizadores(result.data);
        setloadingT(false);   
        return true;                
    });
  }
  
  const [loadingqtdxcanal, setloadingqtdxcanal] = React.useState(false);
  const [dadosQtdContratoxCanalMidia, setdadosQtdContratoxCanalMidia] = React.useState([]);
  const loadQtdContratoxCanalMidia=(obj)=>{     
    setloadingqtdxcanal(true);       
    const endPoint = "dashboard/contratoxcanalmidia/"+session.estabelecimentoId+"/0";
    UsePostApi(endPoint,obj).then(result=>{    
        if(result.status !== 200)
        {   
            showNotification(result.message, 'danger')
            setloadingqtdxcanal(false);
            return false; 
        }   
        setdadosQtdContratoxCanalMidia(result.data);
        setloadingqtdxcanal(false);   
        return true;                
    });
  }

  const [loadingticketsMedios, setloadingticketsMedios] = React.useState(false);
  const [dadosTicketsMedios, setdadosTicketsMedios] = React.useState([]);
  const loadTIcketsMedios=(obj)=>{     
    setloadingticketsMedios(true);       
    const endPoint = "dashboard/ticketsmedios/"+session.estabelecimentoId;
    UsePostApi(endPoint,obj).then(result=>{    
        if(result.status !== 200)
        {   
            showNotification(result.message, 'danger')
            setloadingticketsMedios(false);
            return false; 
        }   
        setdadosTicketsMedios(result.data);
        setloadingticketsMedios(false);   
        return true;                
    });
  }

  const [loadingVendasxPagamentos, setloadingVendasxPagamentos] = React.useState(false);
  const [dadosVendasxPagamentos, setdadosVendasxPagamentos] = React.useState([]);
  const loadVendasxPagamentos=(obj)=>{     
    setloadingVendasxPagamentos(true);       
    const endPoint = "dashboard/vendasxpagamentos/"+session.estabelecimentoId;
    UsePostApi(endPoint,obj).then(result=>{    
        if(result.status !== 200)
        {   
            showNotification(result.message, 'danger')
            setloadingVendasxPagamentos(false);
            return false; 
        }   
        setdadosVendasxPagamentos(result.data);
        setloadingVendasxPagamentos(false);   
        return true;                
    });
  }

  const [loadingAvaliacaoxVendas, setloadingAvaliacaoxVendas] = React.useState(false);
  const [dadosAvaliacaoxVendas, setdadosAvaliacaoxVendas] = React.useState([]);
  const loadAvaliacaoXVendas=(obj)=>{     
    setloadingAvaliacaoxVendas(true);       
    const endPoint = "dashboard/avaliacaoxvendas/"+session.estabelecimentoId;
    UsePostApi(endPoint,obj).then(result=>{    
        if(result.status !== 200)
        {   
            showNotification(result.message, 'danger')
            setloadingAvaliacaoxVendas(false);
            return false; 
        }   
        setdadosAvaliacaoxVendas(result.data);
        setloadingAvaliacaoxVendas(false);   
        return true;                
    });
  } 

  const [loadingTop5Produtos, setloadingTop5Produtos] = React.useState(false);
  const [dadosTop5Prod, setdadosTop5Prod] = React.useState([]);
  const loadTop5Produtos=(obj)=>{     
    setloadingTop5Produtos(true);       
    const endPoint = "dashboard/top5produtos/"+session.estabelecimentoId;
    UsePostApi(endPoint,obj).then(result=>{    
        if(result.status !== 200)
        {   
            showNotification(result.message, 'danger')
            setloadingTop5Produtos(false);
            return false; 
        }   
        setdadosTop5Prod(result.data);
        setloadingTop5Produtos(false);   
        return true;                
    });
  } 

  const [loadingTop5Servicos, setloadingTop5Servicos] = React.useState(false);
  const [dadosTop5Serv, setdadosTop5Serv] = React.useState([]);
  const loadTop5Servicos =(obj)=>{     
    setloadingTop5Servicos(true);       
    const endPoint = "dashboard/top5servicos/"+session.estabelecimentoId;
    UsePostApi(endPoint,obj).then(result=>{    
        if(result.status !== 200)
        {   
            showNotification(result.message, 'danger')
            setloadingTop5Servicos(false);
            return false; 
        }   
        setdadosTop5Serv(result.data);
        setloadingTop5Servicos(false);   
        return true;                
    });
  } 

  const [loadingTop5Pacotes, setloadingTop5Pacotes] = React.useState(false);
  const [dadosTop5Pac, setdadosTop5Pac] = React.useState([]);
  const loadTop5Pacotes =(obj)=>{     
    setloadingTop5Pacotes(true);       
    const endPoint = "dashboard/top5pacotes/"+session.estabelecimentoId;
    UsePostApi(endPoint,obj).then(result=>{    
        if(result.status !== 200)
        {   
            showNotification(result.message, 'danger')
            setloadingTop5Pacotes(false);
            return false; 
        }   
        setdadosTop5Pac(result.data);
        console.log(result.data); 
        setloadingTop5Pacotes(false);   
        return true;                
    });
  } 
  
  const [loadingTop10Vendedores, setloadingTop10Vendedores] = React.useState(false);
  const [dadosTop10Vendedores, setdadosTop10Vendedores] = React.useState([]);
  const loadTop10Vendedores =(obj)=>{     
    setloadingTop10Vendedores(true);       
    const endPoint = "dashboard/rankingtop10vendedor/"+session.estabelecimentoId;
    UsePostApi(endPoint,obj).then(result=>{    
        if(result.status !== 200)
        {   
            showNotification(result.message, 'danger')
            setloadingTop10Vendedores(false);
            return false; 
        }   
        console.log(result.data);
        setdadosTop10Vendedores(result.data);        
        setloadingTop10Vendedores(false);   
        return true;                
    });
  }

  const [loadingTop10Clientes, setloadingTop10Clientes] = React.useState(false);
  const [dadosTop10Clientes, setdadosTop10Clientes] = React.useState([]);
  const loadTop10Clientes =(obj)=>{     
    setloadingTop10Clientes(true);       
    const endPoint = "dashboard/rankingtop10cliente/"+session.estabelecimentoId;
    UsePostApi(endPoint,obj).then(result=>{    
        if(result.status !== 200)
        {   
            showNotification(result.message, 'danger')
            setloadingTop10Clientes(false);
            return false; 
        }   
        setdadosTop10Clientes(result.data);        
        setloadingTop10Clientes(false);   
        return true;                
    });
  }

  return (
    <div>  
      <br/>
      <GridContainer> 
        <GridItem xs={12} sm={6} md={3}>
          <FormControl fullWidth>
              <label style={{backgroundColor:"#dbdbdb"}} className={errors.dtini?"select__label select__label_error":"select__label"}>
                  {t('label.ini_date')+" *"}  </label>
              <Datetime                                    
                  locale={getLocale()}
                  dateFormat={getStringFormatDate()}
                  timeFormat={false}                                    
                  name="dtini"                                      
                  defaultValue={dtini}
                  value={dtini}
                  onChange={date => { setdtini(date) }}
                  inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                  className={errors.dtini?"error":""}            
              />       
              {errors.dtini && <FormHelperText className={classes.labelRootError}>
                  <span> {errors.dtini.message} </span>                                                                          
              </FormHelperText>} 
          </FormControl>                                 
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <label style={{backgroundColor:"#dbdbdb"}} className={errors.dtfim?"select__label select__label_error":"select__label"}>
                {t('label.end_date')+" *"}  </label>
            <Datetime                            
                locale={getLocale()}
                dateFormat={getStringFormatDate()}
                timeFormat={false}                                    
                name="dtfim"                                      
                defaultValue={dtfim}
                value={dtfim}
                onChange={date => { setdtfim(date) }}
                inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                className={errors.dtfim?"error":""}            
            />       
            {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                <span> {errors.dtfim.message} </span>                                                                          
            </FormHelperText>} 
          </FormControl>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>                        
            <Button round color="primary" size="sm" onClick={e => { handleClickPesquisa()}}>
              {t('button.search')}
            </Button>               
        </GridItem>            
        <GridItem xs={12} sm={12} md={12}>          
        {notification.show &&
          <div><br/>
          <SnackbarContent
              message={notification.message}
              color={notification.color}
              closeNotification={() => setNotification({show:false})}
              close
          /></div>} 
          <br/> 
        </GridItem>
      </GridContainer>

      <GridContainer> 
        <GridItem xs={12} sm={6} md={3}>                              
            <div className="cardB">              
                <div style={{textAlign:'right'}}>
                    <label><b>{totalizadores.qtdVendas}</b> {t('dashboard.sales')}</label>
                </div>
                <div>
                    {!loadingT && <h4>
                      {transformValueFloattoFormated(totalizadores.valorTotal ? totalizadores.valorTotal : 0)}
                    </h4>}
                    {loadingT && <CircularProgress size={20} style={{marginLeft:'10px'}} />}
                </div>
                <div className="ico">
                    <Equalizer style={{fontSize:'35px'}} />
                </div>
                <div style={{clear:'both'}}></div>
                <label>{t('dashboard.total_sale_value')}</label>
            </div>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>                               
            <div className="cardB">              
                <div style={{textAlign:'right'}}>
                    <label><b>{totalizadores.qtdPacotes}</b> {t('dashboard.packages')}</label>
                </div>
                <div>
                    {!loadingT && <h4>
                      {transformValueFloattoFormated(totalizadores.valorTotalPacotes ? totalizadores.valorTotalPacotes : 0)}
                    </h4>}
                    {loadingT && <CircularProgress size={20} style={{marginLeft:'10px'}} />}
                </div>
                <div className="ico">
                    <Equalizer style={{fontSize:'35px'}} />
                </div>
                <div style={{clear:'both'}}></div>
                <label>{t('dashboard.total_package_value')}</label>
            </div>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>                              
            <div className="cardB">              
                <div style={{textAlign:'right'}}>
                    <label><b>{totalizadores.qtdServicos}</b> {t('dashboard.services')}</label>
                </div>
                <div>
                    {!loadingT && <h4>
                      {transformValueFloattoFormated(totalizadores.valorTotalServicos ? totalizadores.valorTotalServicos : 0)}
                    </h4>}
                    {loadingT && <CircularProgress size={20} style={{marginLeft:'10px'}} />}
                </div>
                <div className="ico">
                    <Equalizer style={{fontSize:'35px'}} />
                </div>
                <div style={{clear:'both'}}></div>
                <label> {t('dashboard.total_service_value')}</label>
            </div>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>                               
            <div className="cardB">              
                <div style={{textAlign:'right'}}>
                    <label><b>{totalizadores.qtdProdutos}</b> {t('dashboard.products')}</label>
                </div>
                <div>
                    {!loadingT && <h4>
                      {transformValueFloattoFormated(totalizadores.valorTotalProdutos ? totalizadores.valorTotalProdutos : 0)}
                    </h4>}
                    {loadingT && <CircularProgress size={20} style={{marginLeft:'10px'}} />}
                </div>
                <div className="ico">
                    <Equalizer style={{fontSize:'35px'}} />
                </div>
                <div style={{clear:'both'}}></div>
                <label>{t('dashboard.total_product_value')}</label>
            </div>
        </GridItem>  
      </GridContainer>

      <GridContainer>
      
      <GridItem xs={12} sm={12} md={5} >
        <Card>
          <CardHeader icon>
              <CardIcon color="primary">
                <PieChart />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
              {t('dashboard.salesxmidia')}
              </h4>
            </CardHeader>
          <CardBody style={{height:'350px'}}>
            
            {loadingqtdxcanal && <div className="loadingDash"><CircularProgress size={40} /></div>}
            {(!loadingqtdxcanal && dadosQtdContratoxCanalMidia.length > 0) &&
              <PieGraph data={dadosQtdContratoxCanalMidia} />
            }
            {(!loadingqtdxcanal && dadosQtdContratoxCanalMidia.length ==0) &&
            <div className="showNoData">
              <TimerOff style={{fontSize:'40px'}}/>
              <h4>
                <Trans i18nKey="dashboard.message_no_data">
                  Oops,<br/>Não há dados nesse período.
                </Trans>
              </h4>
            </div>}
          </CardBody>  
        </Card>
      </GridItem>
     
      <GridItem xs={12} sm={12} md={7} >
        <Card>
          <CardHeader icon>
              <CardIcon color="primary">
                <BarChart />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
              {t('dashboard.average_ticket')}
              </h4>
            </CardHeader>
          <CardBody style={{height:'350px'}}>

            {loadingticketsMedios && <div className="loadingDash"><CircularProgress size={40} /></div>}
            {(!loadingticketsMedios && dadosTicketsMedios.length > 0) &&              
              <BarGraph data={dadosTicketsMedios}/>
            }
            {(!loadingticketsMedios && dadosTicketsMedios.length ==0) &&
            <div className="showNoData">
              <TimerOff style={{fontSize:'40px'}}/>
              <h4>
                <Trans i18nKey="dashboard.message_no_data">
                  Oops,<br/>Não há dados nesse período.
                </Trans>
              </h4>
            </div>}
        
          </CardBody>  
        </Card>
      </GridItem>     
      
      <GridItem xs={12} sm={12} md={6} >
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <BarChart />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {t('dashboard.sales_by_payment')}
            </h4>
          </CardHeader>
          <CardBody style={{height:'350px'}}>
           
            {loadingVendasxPagamentos && <div className="loadingDash"><CircularProgress size={40} /></div>}
            {(!loadingVendasxPagamentos && dadosVendasxPagamentos.length > 0) &&              
               <Bar2Graph data={dadosVendasxPagamentos}/>
            }
            {(!loadingVendasxPagamentos && dadosVendasxPagamentos.length ==0) &&
            <div className="showNoData">
              <TimerOff style={{fontSize:'40px'}}/>
              <h4>
                <Trans i18nKey="dashboard.message_no_data">
                  Oops,<br/>Não há dados nesse período.
                </Trans>
              </h4>
            </div>}
        
          </CardBody>   
        </Card>
      </GridItem>
      
      <GridItem xs={12} sm={12} md={6} >
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Timeline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {t('dashboard.salesxavaliation')}
            </h4>
          </CardHeader>
          <CardBody style={{height:'350px'}}>
           
            {loadingAvaliacaoxVendas && <div className="loadingDash"><CircularProgress size={40} /></div>}
            {(!loadingAvaliacaoxVendas && dadosAvaliacaoxVendas.length > 0) &&              
               <LineGraph data={dadosAvaliacaoxVendas}/>
            }
            {(!loadingAvaliacaoxVendas && (dadosAvaliacaoxVendas.length === 0 )) &&
            <div className="showNoData">
              <TimerOff style={{fontSize:'40px'}}/>
              <h4>
                <Trans i18nKey="dashboard.message_no_data">
                  Oops,<br/>Não há dados nesse período.
                </Trans>
              </h4>
            </div>}
        
          </CardBody>   
        </Card>
      </GridItem>

      <GridItem xs={12} sm={12} md={4} >
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <PieChart />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {t('dashboard.packages_top_5')}
            </h4>
          </CardHeader>
          <CardBody style={{height:'250px'}}>

            {loadingTop5Pacotes && <div className="loadingDash"><CircularProgress size={40} /></div>}
            {(!loadingTop5Pacotes && dadosTop5Pac.length > 0) && 
              <Pie2Graph data={dadosTop5Pac} />
            }
            {(!loadingTop5Pacotes && dadosTop5Pac.length ==0) &&
            <div className="showNoData">
              <TimerOff style={{fontSize:'40px'}}/>
              <h4>
                <Trans i18nKey="dashboard.message_no_data">
                  Oops,<br/>Não há dados nesse período.
                </Trans>
              </h4>
            </div>}
        
          </CardBody>    
        </Card>
      </GridItem>

      <GridItem xs={12} sm={12} md={4} >
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <PieChart />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {t('dashboard.services_top_5')}             
            </h4>
          </CardHeader>
          <CardBody style={{height:'250px'}}>

            {loadingTop5Servicos && <div className="loadingDash"><CircularProgress size={40} /></div>}
            {(!loadingTop5Servicos && dadosTop5Serv.length > 0) && 
              <Pie2Graph data={dadosTop5Serv} />
            }
            {(!loadingTop5Servicos && dadosTop5Serv.length ==0) &&
            <div className="showNoData">
              <TimerOff style={{fontSize:'40px'}}/>
              <h4>
                <Trans i18nKey="dashboard.message_no_data">
                  Oops,<br/>Não há dados nesse período.
                </Trans>
              </h4>
            </div>}
        
          </CardBody>    
        </Card>
      </GridItem>

      <GridItem xs={12} sm={12} md={4} >
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <PieChart />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {t('dashboard.products_top_5')}
            </h4>
          </CardHeader>
          <CardBody style={{height:'250px'}}>

            {loadingTop5Produtos && <div className="loadingDash"><CircularProgress size={40} /></div>}
            {(!loadingTop5Produtos && dadosTop5Prod.length > 0) &&
            <Pie2Graph data={dadosTop5Prod} />
            }
            {(!loadingTop5Produtos && dadosTop5Prod.length ==0) &&
            <div className="showNoData">
              <TimerOff style={{fontSize:'40px'}}/>
              <h4>
                <Trans i18nKey="dashboard.message_no_data">
                  Oops,<br/>Não há dados nesse período.
                </Trans>
              </h4>
            </div>}
        
          </CardBody> 
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={6} >
        <Card>
          <CardHeader icon>
              <CardIcon color="primary">
                <BarChart />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
              {t('dashboard.clients_top_10')} 
              </h4>
            </CardHeader>
          <CardBody>
            {loadingTop10Clientes && <div className="loadingDash"><CircularProgress size={40} /></div>}
            {(!loadingTop10Clientes && dadosTop10Clientes.length > 0) && 
                <table className="table table-bordered">
                <thead>
                  <tr>
                  <th>{t('dashboard.ranking')} </th>
                    <th>{t('label.client')} </th>
                    <th>{t('dashboard.average_ticket')}</th>
                    <th>{t('dashboard.sales_qty')}</th>
                  </tr>
                </thead>
                <tbody> 
                  {dadosTop10Clientes.map((item, index) => (
                    <tr key={item.nome}>
                        <td>{index + 1}º</td>
                        <td>{item.nome}</td>
                        <td style={{textAlign:'right'}}>{"R$ "+ transformValueFloattoFormated(item.ticketMedio)}</td>
                        <td style={{textAlign:'right'}}>{item.qtdVendas}</td>
                    </tr>
                  ))}                  
                </tbody>
              </table> 
            }
            {(!loadingTop10Clientes && dadosTop10Clientes.length ==0) &&
            <div className="showNoData">
              <TimerOff style={{fontSize:'40px'}}/>
              <h4>
                <Trans i18nKey="dashboard.message_no_data">
                  Oops,<br/>Não há dados nesse período.
                </Trans>
              </h4>
            </div>}

          </CardBody>  
        </Card>
      </GridItem> 
      <GridItem xs={12} sm={6} md={6} >
        <Card>
          <CardHeader icon>
              <CardIcon color="primary">
                <BarChart />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
              {t('dashboard.sellers_top_10')} 
              </h4>
            </CardHeader>
          <CardBody>
            {loadingTop10Vendedores && <div className="loadingDash"><CircularProgress size={40} /></div>}
            {(!loadingTop10Vendedores && dadosTop10Vendedores.length > 0) && 
                <table className="table table-bordered">
                <thead>
                  <tr>
                  <th>{t('dashboard.ranking')} </th>
                    <th>{t('dashboard.seller')} </th>
                    <th>{t('dashboard.average_ticket')}</th>
                    <th>{t('dashboard.sales_qty')}</th>
                  </tr>
                </thead>
                <tbody> 
                  {dadosTop10Vendedores.map((item, index) => (
                    <tr key={item.nome}>
                        <td>{index + 1}º</td>
                        <td>{item.nome}</td>
                        <td style={{textAlign:'right'}}>{"R$ "+ transformValueFloattoFormated(item.ticketMedio)}</td>
                        <td style={{textAlign:'right'}}>{item.qtdVendas}</td>
                    </tr>
                  ))}                  
                </tbody>
              </table> 
            }
            {(!loadingTop10Vendedores && dadosTop10Vendedores.length ==0) &&
            <div className="showNoData">
              <TimerOff style={{fontSize:'40px'}}/>
              <h4>
                <Trans i18nKey="dashboard.message_no_data">
                  Oops,<br/>Não há dados nesse período.
                </Trans>
              </h4>
            </div>}

          </CardBody>  
        </Card>
      </GridItem> 
    </GridContainer>

    </div>
  );
}
